<div style="width: 100%; height: 100%; min-height: 200px; overflow-y: auto;">
    <ag-grid-angular
        #mainGrid
        style="height: 100%; width: 100%; padding: 5px;"
        id="review-requests-grid"
        class="ag-theme-alpine ag-grid-container"
        [gridOptions]="gridOptions"
        [debug]="true"
    ></ag-grid-angular>
  </div>